import React, { Fragment, useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import { descargarDocumento } from "./Seguridad/DescargarDocumento";

function DescripcionAutoevaluacion(props) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };

  const [list, setList] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/QSubtituloSolicitudSubtitulo?SolicitudId=" +
        props.idSolicitud +
        "&SubtituloId=" +
        props.SubId,
    })
      .then((Response) => {
        setList(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList]);

  const [list1, setList1] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerAdjuntoAutoEvaluacion?SolicitudId=" +
        props.idSolicitud +
        "&SubtituloId=" +
        props.subtitulo,
    })
      .then((Response) => {
        setList1(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList1]);
  return (
    <div>
      <div>
        <button
          className="btn btn-primarbtn btn-primary btn-user btn-block"
          onClick={handleOpenModalTest}
        >
          {" "}
          Descripción{" "}
        </button>
        <ReactModal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          contentLabel="Crear"
        >
          <div className="container">
            <div className="text-justify">
              <div class="container-fluid">
                <div class="card shadow mb-4">
                  <div class="card-header py-3">
                    <h6 class="m-0 font-weight-bold text-primary">
                      Informacion Autoevaluacion{props.subTitulo}
                    </h6>
                  </div>
                  <div class="card-body">
                    <div class="table-responsive">
                      <table
                        class="table table-bordered"
                        id="dataTable"
                        width="100%"
                        cellspacing="0"
                      >
                        <thead>
                          <tr>
                            <th>Descripción</th>
                          </tr>
                        </thead>
                        <tbody>
                          {list.map((item) => {
                            return (
                              <tr>
                                <td>{item.descripcion}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div class="table-responsive">
                      <table
                        class="table table-bordered"
                        id="dataTable"
                        width="100%"
                        cellspacing="0"
                      >
                        <thead>
                          <tr>
                            <th hidden>
                              adjuntos{props.subTitulo}....
                              {props.idSolicitud}{" "}
                            </th>
                            <th>Adjuntos</th>
                          </tr>
                        </thead>
                        <tbody>
                          {list1.map((item) => {
                            return (
                              <tr>
                                <td>
                                  <button
                                    className="btn btn-success"
                                    onClick={() =>
                                      descargarDocumento(item.urlUbicacion)
                                    }
                                  >
                                    Descargar: {item.urlUbicacion}
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ReactModal>
      </div>
    </div>
  );
}

export default DescripcionAutoevaluacion;
